import * as React from "react";
import CompanyRadarChart, { RadarAxis } from "./CompanyRadarChart";
import {
  CompanyProfileCard,
  CompanyProfileCardTitle,
} from "./CompanyProfileCard";

interface CompanyRadarCardProps {
  axes: RadarAxis[];
  isLoading: boolean;
  isError: boolean;
}

const CompanyRadarCard: React.FC<CompanyRadarCardProps> = ({
  axes,
  isLoading,
  isError,
}) => (
  <CompanyProfileCard className="flex flex-col xl:min-h-[297px]">
    <CompanyProfileCardTitle>レーダーチャート指標</CompanyProfileCardTitle>
    <div className="flex min-h-[200px] flex-1 items-center justify-center pt-[15px]">
      <CompanyRadarChart axes={axes} isLoading={isLoading} isError={isError} />
    </div>
  </CompanyProfileCard>
);

export default CompanyRadarCard;
